/**
 * HITL-1614 / HITL-1617 — which cart a write, or a rendered row, belongs to.
 *
 * `main` is `cartSlice`: the AI cart in `Supervise` and `Shadow`, the order in
 * `Intercept` and with the flag off. `draft` is `draftCart` (HITL-1611's My
 * Cart), which the AI's hypothesis rebuild cannot reach and which never sends an
 * order.
 *
 * Deliberately dependency-free. HITL-1614 declared these in
 * `CartScopeContext.tsx` because only a React subtree needed them; HITL-1617
 * gives the same vocabulary to `dialogSlice` and to two thunks, and a reducer
 * importing a type out of a `.tsx` component is backwards. `CartScopeContext`
 * re-exports all three, so nothing that imported them from there had to change.
 */
export type CartScope = 'main' | 'draft';

export const MAIN_CART_SCOPE: CartScope = 'main';
export const DRAFT_CART_SCOPE: CartScope = 'draft';
